var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { useParams } from "react-router-dom";
import { convertCommentFromServer } from "../../../../utils/comment";
import { convertTaskFromServer } from "../../../../utils/task";
import { useCommentActions } from "../../../hooks/actions/useCommentActions";
import { useTaskActions } from "../../../hooks/actions/useTaskActions";
import { UserPageAppContext } from "../../../providers/UserPageAppContextProvider";
import { CommentsApp } from "../../CommentsApp/CommentsApp";
import { PageContentWrap, PageTitle, PageWrap } from "../Page/Page";
function TaskCommentsPage() {
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { taskHash } = useParams();
    const [loading, setLoading] = useState(true);
    const [task, setTask] = useState(null);
    const [comments, setComments] = useState(null);
    const { loadTaskComments, addTaskComment } = useCommentActions();
    const { getTask } = useTaskActions();
    useEffect(() => {
        loadTask();
        loadComments();
    }, []);
    const loadTask = () => __awaiter(this, void 0, void 0, function* () {
        yield getTask(pageHash, taskHash, (data) => {
            setTask(convertTaskFromServer(data.task));
        });
    });
    const loadComments = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield loadTaskComments(pageHash, taskHash, (comments) => {
            setComments(comments.map(convertCommentFromServer));
        });
        setLoading(false);
    });
    const onAddComment = (comment) => __awaiter(this, void 0, void 0, function* () {
        yield addTaskComment(task.task_hash, comment, (comments) => {
            setComments(comments);
        });
    });
    return (_jsx(PageWrap, { loading: loading, onRefresh: loadComments, children: _jsxs(PageContentWrap, { children: [task && (_jsx(PageTitle, { description: __("Comments related to the task", "quicktasker"), children: sprintf(__("%s comments", "quicktasker"), task.name) })), comments && (_jsx(CommentsApp, { comments: comments, addComments: onAddComment }))] }) }));
}
export { TaskCommentsPage };
